export const ON_DOWNLOAD_CLICK = "ON_DOWNLOAD_CLICK";



// WEBPACK FOOTER //
// ./src/store/analytics/chart-download/actions.js